import { useQuery } from '@apollo/client';
import { getStoreFreight } from '@catalogo/service-americanas-product/src/queries/store.graphql';

export const useFreightLasa = ({ persistentCep, offer, dispatchMetrics, currentStore = {}, productQty = 1 }) => {
  const skuId = offer?.sku;
  const sellerId = offer?.seller?.id;
  const products = { storeId: sellerId, sku: skuId, quantity: productQty };

  if (currentStore?.sellerStoreId) {
    products.sellerStoreId = currentStore?.sellerStoreId;
  }

  const { previousData, data, loading } = useQuery(getStoreFreight, {
    variables: {
      cep: persistentCep,
      products,
    },
    ssr: false,
    onCompleted: /* istanbul ignore next */ data => {
      dispatchMetrics('freight:event', data);
    },
    skip: !persistentCep || !skuId || !sellerId,
  });

  return { previousData, data, loading };
};
